module.exports = __webpack_public_path__ + "static/media/islands_sm.3eb58023.jpg";